<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] <sui-label>" />

    <!-- Page Contents -->
    <sui-page-contents>
      <div class="comm_title_wrap">
        <h3>sui-label</h3>
      </div>

      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-label label="<sui-label>" />
          </div>
          <div class="col-xs-5">
            <sui-label label="샬라샬라 라벨 테스트" />
          </div>
          <div class="col-xs-6">
            <span class="info">// label</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-label label="<sui-label>" />
          </div>
          <div class="col-xs-5">
            <sui-label
              label="샬라샬라 라벨 테스트"
              required
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// label, required</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-label label="<sui-label>" />
          </div>
          <div class="col-xs-5">
            <sui-label
              label="333333333333333333"
              format="currency"
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// label, currency</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-label label="<sui-label>" />
          </div>
          <div class="col-xs-5">
            <sui-label
              label="샬라샬라 라벨 테스트 긴 텍스트 긴거 긴거 긴거 긴거 긴거 긴거긴거 긴거 긴거긴거 긴거 긴거긴거 긴거 긴거긴거 긴거 긴거긴거 긴거 긴거긴거 긴거 긴거긴거 긴거 긴거"
              width="200"
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// label, width="200", 긴 문장 두줄표현(...)</span>
          </div>
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
export default {
  name: 'CompGuideLabel',
  data() {
    return {};
  },
  computed: {
  },
  watch: {},
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped>
</style>
